const showLimitedUserAlert = (self, options = {}) => {
  const defaultOptions = {
    message: self.$t('description.processLimitedUserAlert'),
    confirmText: self.$t('button.goToPaidMembership'),
    cancelText: self.$t('button.later'),
    onConfirm: () => {
      self.$router.push({ name: 'payment' })
    }
  }
  const dialogOptions = Object.assign(options, defaultOptions)
  self.$buefy.dialog.confirm(dialogOptions)
}

export default { showLimitedUserAlert }
